import { TLoginResponse, TUser } from '../../types';

export type TEventBusEvent<T> = {
  data: T;
  meta: {
    appName: string;
    location?: string;
    appVersion?: string;
  };
  onSuccess?: () => boolean | void;
  onError?: () => void;
};

export enum Events {
  THEME_CHANGE = 'theme:change',
  NAVIGATE = 'navigate',
  USER_LOGOUT = 'user:logout',
  USER_LOGIN = 'user:login',
  USER_UPDATE_SESSION = 'user:update',
  SIDEBAR_TOGGLE = 'sidebar:toggle'
}

export type TEventBusEventsMap = {
  [Events.NAVIGATE]: (event: TEventBusEvent<string>) => void;
  [Events.THEME_CHANGE]: (event: TEventBusEvent<'dark' | 'light'>) => void;
  [Events.USER_LOGOUT]: (event: TEventBusEvent<void>) => void;
  [Events.USER_UPDATE_SESSION]: (
    event: TEventBusEvent<{ loginResponse: TLoginResponse; goto?: string }>
  ) => void;
  [Events.USER_LOGIN]: (
    event: TEventBusEvent<{ loginData: TLoginResponse; userData: TUser }>
  ) => void;
  [Events.SIDEBAR_TOGGLE]: (event: TEventBusEvent<undefined | boolean>) => void;
};
